var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "register" }, [
    _c(
      "body",
      {
        staticClass: "account-page",
        staticStyle: {
          "font-family": "'CircularStd', sans-serif",
          "font-size": ".9375rem",
          color: "#1f1f1f",
          "background-color": "#f7f7f7",
          "min-height": "100%",
          "overflow-x": "hidden"
        }
      },
      [
        _c("div", { staticClass: "main-wrapper" }, [
          _c("div", { staticClass: "account-content" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "account-logo" },
                [
                  _c("router-link", { attrs: { to: "/index" } }, [
                    _c("img", {
                      attrs: { src: _vm.logoText, alt: _vm.appTitle }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "account-box" }, [
                _c(
                  "div",
                  { staticClass: "account-wrapper" },
                  [
                    _c("h3", { staticClass: "account-title" }, [
                      _vm._v("Otp Confirmation")
                    ]),
                    _vm._v(" "),
                    _vm.isError
                      ? _c("div", { staticClass: "alert alert-danger" }, [
                          _vm._v(_vm._s(_vm.msgError))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSuccess
                      ? _c("div", { staticClass: "alert alert-success" }, [
                          _vm._v(_vm._s(_vm.msgSuccess))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("center", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-md",
                          attrs: { disabled: _vm.isDisabled, type: "submit" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push("/")
                            }
                          }
                        },
                        [_vm._v("« Back to Home")]
                      )
                    ])
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38c5d16e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38c5d16e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/register/confirm.vue
// module id = null
// module chunks = 